import axios from 'axios';
import { emailService } from '../../../../config';
 const endpoint = emailService.uri;
//  const endpoint =  "https://localhost:7020/graphql/"
// Utility function to get authorization headers
const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;
  return {
    'Authorization': formattedToken, 
    'Content-Type': 'application/json',
  };
};
export const fetchEmails = async (page = 0, pageSize = 25) => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  const FETCH_EMAILS = `
    query EmailsByCompany($pageNumber: Int!, $pageSize: Int!){
  emailsByCompany (pageNumber: $pageNumber, pageSize: $pageSize, includeTotalCount: true) {
  totalCount
  emails{
    body
    companyName
    companyEmail
    companyId
    contactEmailPassword
    createdBy
    createdDate
    emailClient
    emailClientPortNumber
    emailDisplayName
    encrypted
    failedReason
    fileName
    fileType
    hasFile
    isActive
    id
    recipientEmail
    retries
    sentDateTime
    status
    statusFlag
    subject
    subjectTitle
    updatedBy
    updatedDate
  }
}
}
  `;

  try {
    const response = await axios.post(
       endpoint,
      //"https://localhost:7020/graphql/",
       {
      query: FETCH_EMAILS,
      variables: { // Add variables to the request
          pageNumber: page,
          pageSize: pageSize,
          includeTotalCount: true,
        }
       },
    {
        headers:{
          'Authorization': formattedToken, 
          'Content-Type': 'application/json',
        },
    });

    const emails = response.data.data.emailsByCompany;
      console.log("emails:",emails)
    if (!emails) {
      throw new Error("No emails found");
    }
      return {
      emails: emails.emails,
      totalCount: emails.totalCount
    }; 
  } catch (error) {
    console.error('Error fetching emails:', error.message || error);
    return {emails: [], totalCount: 0};
  }
};

export const createEmailMessage = async (emailInput) => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  const mutation = `
    mutation CreateEmailMessage($email: EmailMessagesInput!) {
      createEmailMessage(email: $email) {
        id
        recipientEmail
        subject
        subjectTitle
        body
        companyId
        
      }
    }
  `;

  const variables = {
    email: emailInput,
  };

  try {
    const response = await axios.post(endpoint, {
      query: mutation,
      variables,
    }, {
      headers:{
        'Authorization': formattedToken, 
        'Content-Type': 'application/json',
      },
    });

    return response.data.data.createEmailMessage;
  } catch (error) {
    console.error('Error creating email message:', error);
    return null;
  }
};

export const sendBulkEmails = async (emailMessages) => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

    const mutation = `
        mutation CreateEmailMessages($emailMessages: EmailMessagesInput!) {
            createEmailMessages(emailMessages: $emailMessages) {
                id
                recipientEmail
                subject
                body
                sentDateTime
                status
                isActive
                createdBy
                createdDate
            }
        }
    `;

    const response = await axios.post(endpoint, {
        query: mutation,
        variables: { emailMessages }, // Correctly named variable
    }, {
      headers:{
        'Authorization': formattedToken, 
        'Content-Type': 'application/json',
      },
    });

    return response.data.data.createEmailMessages; // Return the created email messages data
};

// Function to send a single email
export const sendEmail = async (emailInput) => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

    const mutation = `
        mutation CreateEmailMessage($emailMessages: EmailMessagesInput!) {
            createEmailMessage(emailMessages: $emailMessages) { // Use emailMessages instead of email
                id
                recipientEmail
                subject
                body
                sentDateTime
                status
                isActive
                createdBy
                createdDate
            }
        }
    `;

    const variables = {
        emailMessages: { // Correctly named variable
            email: emailInput, // Ensure you are nesting email input correctly
        },
    };

    const response = await axios.post(endpoint, {
        query: mutation,
        variables,
    }, {
      headers:{
        'Authorization': formattedToken, 
        'Content-Type': 'application/json',
      },
    });

    return response.data.data.createEmailMessage; // Return the created email message data
};
